import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Swag = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M6 2.667a.667.667 0 0 0-1.333 0v6.666H3.333v-2a.667.667 0 0 0-1.333 0v2.44c0 1.593 1.113 2.949 2.667 3.451v2.11H3.333V14C1.74 13.156.667 11.579.667 9.773v-2.44a2 2 0 0 1 2.666-1.886v-2.78a2 2 0 1 1 4 0v.78a1.997 1.997 0 0 1 2 .396 1.993 1.993 0 0 1 2-.396v-.78a2 2 0 0 1 4 0v7.106c0 1.806-1.072 3.383-2.666 4.227v1.333h-1.334v-2.109C12.887 12.722 14 11.366 14 9.773V2.667a.667.667 0 0 0-1.333 0v6h-1.334V5.333a.667.667 0 1 0-1.333 0v3.334H8.667V5.333a.667.667 0 1 0-1.334 0v3.334H6v-6Z"
      fill="currentColor"
    />
  </Icon>
));

export default Swag;
